import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, TagSelect } from '@piplapps/pipl-ui';
import styles from './AssignToTeamsModal.module.less';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import { UsersSelectors } from '../../../../Redux/modules/users/selectors';
import LoadingButton from '../../../../Components/LoadingButton';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const assignToTeamsModal = (props) => {
  // eslint-disable-next-line camelcase
  const { id, email, first_name, last_name } = props.userData;
  const teamIds = props.userData.teams?.map((team) => team.id);

  const [teams, setTeams] = useState(teamIds);
  const [teamsNames, setTeamsNames] = useState([]);

  const teamOptions = props.teams?.map((team) => {
    return { label: team.name, value: team.id.toString() };
  });

  return (
    <div className={styles.modalContainer}>
      <span tabIndex={0} role="button" className={styles.close} onClick={() => props.clickedCloseModalButton()}>
        &times;
      </span>
      <div className={styles.header}>{gettext('Assign team')}</div>
      <div className={styles.email}>
        <div>
          <strong>{`${first_name} ${last_name}`}</strong>
        </div>
        <div>
          <strong>{`${email}`}</strong>
        </div>
      </div>
      <div className={styles.inputWrapper}>
        <div className={styles.inputWrapper}>
          <TagSelect
            options={teamOptions}
            name="teamsSelect"
            id="teamsSelect"
            testId="teamsSelect"
            onChange={(value) => {
              setTeams(value.map((team) => parseInt(team.value, 10)));
              setTeamsNames(value.map((team) => team.label));
            }}
            values={teams?.map((team) => team.toString()) || []}
            label={gettext('Select team')}
            isSearchable={false}
            emptyChoicesText="No team is assigned"
            tagsCaption={teams?.length > 1 ? 'Selected teams' : 'Selected team'}
            tagsCaptionClassName={styles.tagsCaption}
            closeMenuOnSelect
          />
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <div className={styles.buttonUpdate}>
          <AnalyticsHandler
            eventName={AnalyticsEventNames.ASSIGN_TO_TEAMS}
            eventData={{
              manipulatedUser: id,
              manipulatedUserEmail: email,
              teams: teamsNames,
              teamsPreviousState: props.userData.teams ? props.userData.teams.map((team) => team.name) : [],
            }}
          >
            <LoadingButton
              buttonClass="primary-blue"
              type="submit"
              text={gettext('Save')}
              width="39%"
              loadingText={gettext('Saving')}
              onClick={() => props.onAssignToTeams({ userId: id, teams })}
              id="submit-button"
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonCancel}>
          <Button
            buttonClass="secondary-blue"
            onClick={() => props.clickedCloseModalButton()}
            text={gettext('Cancel')}
          />
        </div>
      </div>
    </div>
  );
};

assignToTeamsModal.propTypes = {
  userData: PropTypes.object,
  onAssignToTeams: PropTypes.func,
  modalError: PropTypes.bool,
  modalErrorMessage: PropTypes.string,
  clickedCloseModalButton: PropTypes.func,
  teams: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    modalError: UsersSelectors.modalErrorSelector(state),
    modalErrorMessage: UsersSelectors.modalErrorMessageSelector(state),
    teams: UsersSelectors.teamsSelector(state),
  };
};

const mapDispatchToProps = {
  onAssignToTeams: UsersActions.assignToTeams,
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
};

export default connect(mapStateToProps, mapDispatchToProps)(assignToTeamsModal);
